import { Injectable, OnInit } from '@angular/core';
import { BehaviorSubject, throwError, } from 'rxjs';
import { Router } from '@angular/router';
import { User } from './user';
import { LoginApiServiceService } from '../services/login-api-service.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError, tap } from 'rxjs/operators';

@Injectable()

export class AuthService implements OnInit {
  //authguard login variable
  public loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  // Data Manipulation variables
  logintoken: any = [];
  //authguard login variable
  isLoggedIn = false;

  constructor(private router: Router,
    private loginservice: LoginApiServiceService,private http:HttpClient ) {

    
    // Navigate to the login page and clear session and local storage
    if (window.location.pathname == "/login" || window.location.pathname == "/") {
      sessionStorage.setItem('isLogin', 'false');
      sessionStorage.clear();
    }

  }
  
  ngOnInit() {
  }

  loginUser(body:any){
    return this.http.post(`${environment.baseUrl}token`,body);
  }

  //login method
  async login(user: User) {
       let promise = new Promise((reslove:any, reject:any)=>{
          this.loginservice.getLoginData(user.email, user.password).subscribe((data: {}) => {
            this.logintoken = data;
            if (this.logintoken['access_token']) {
              this.isLoggedIn = true;
              sessionStorage.setItem("access_token", this.logintoken['access_token']);
              sessionStorage.setItem("expiry", this.logintoken['expires_in']);
              sessionStorage.setItem("loginUserId", this.logintoken['user_details']['id']);
              sessionStorage.setItem('userDetails',JSON.stringify(this.logintoken['user_details']));
              reslove("");
            } else {
              reject("User Login Faild..");
            }
          }, (Error: any) => {
            if (Error.status === 400) {
              reject("User Login Faild..");
            }
    
            if (Error.status === 401) {
              reject("User Login Faild..");
            }
          });
        });
        return promise;
  }

  getRefreshtoken() {
    var refreshToken = sessionStorage.getItem("refreshToken");
    this.loginservice.getRefreshToken(refreshToken).subscribe((data: any) => {
      sessionStorage.setItem('accessToken', data.accessToken);

    })
  }

  //Navigate to the login page
  logout() {
    sessionStorage.setItem('isLogin', 'false');
    sessionStorage.clear();
    this.router.navigate(['/login'])
  }

  
  handleError(error: any) {
    let errorCode = '';
    if (error.error instanceof HttpErrorResponse) {
    } else {
      errorCode = `${error.status}`;
    }
    
    if(errorCode === "400"){
      window.location.href = '/login'
    }
    return throwError(errorCode);
  }

   //refresh method
   refreshTokens(){
    return this.http.get(environment.baseUrl+'/refreshToken')
      .pipe(
        tap((tokens: any) => {
          sessionStorage.setItem('accessToken', tokens.accessToken);
          console.log('Refresh token ok');
        }),catchError(this.handleError)
      )
  }

}